import { FC } from 'react';
import { PimImage } from 'src/components/common/PimImage';
import { Paragraph } from 'src/components/common/typography/Text';
import { useTranslateItem } from 'src/hooks/directus/useTranslateItem';
import {
  ProductImagesValuesAttribute,
  ProductTextValuesAttribute,
} from 'src/models/pim/attributes';
import { media } from 'src/styles/designs';
import styled from 'styled-components';

export interface TechnicalFeatureItemProps {
  title: ProductTextValuesAttribute['item'] | undefined;
  description: ProductTextValuesAttribute['item'] | undefined;
  image: ProductImagesValuesAttribute['item']['value'][number] | undefined;
}

const Container = styled.div`
  width: 100%;
  ${media.w.greaterThanOrEqual.desktop} {
    width: 430px;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  width: 335px;
  height: 335px;
  margin-bottom: 32px;
`;

const Heading = styled.h3`
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 0 16px;
`;

export const TechnicalFeatureItem: FC<TechnicalFeatureItemProps> = ({
  title,
  description,
  image,
}) => {
  const translateFn = useTranslateItem();

  return (
    <Container>
      {image && (
        <ImageContainer>
          <PimImage
            src={image.directus_files_id.id}
            layout="fill"
            objectFit="contain"
            objectPosition="0 50%"
            sizes="100vw"
          />
        </ImageContainer>
      )}
      {title && <Heading>{translateFn(title).value}</Heading>}
      {description && <Paragraph>{translateFn(description).value}</Paragraph>}
    </Container>
  );
};
